export enum ProcedureInstanceStepStatus{
    NotStarted = 'Not Started',
    Skipped = 'Skipped',
    Completed = 'Completed',
}